export default __webpack_public_path__ + "static/media/about-img-04@medium.e553dc7b.jpg";